import type { GridStack, GridStackNode } from 'gridstack';
import type { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';
import type { AnyWidgetDef } from '@core/dashboard-types';

export const { inject: injectDashboardWidgets, provide: provideDashboardWidget } =
  createProviderToken<Observable<AnyWidgetDef>>('DASHBOARD_WIDGET_TOKEN')(true);

export const withAnimationsDisabled = (grid: GridStack, fn: Function) => {
  grid.setAnimation(false);
  fn();
  grid.setAnimation(true);
};

export const gridstackMoveToTop = (node: GridStackNode) => {
  if (!node.grid) return;

  withAnimationsDisabled(node.grid, () => node.grid!.engine.moveNode(node, { x: 0, y: 0 }));
};

export const gridstackMoveUnder = (target: GridStackNode, node: GridStackNode) => {
  if (!node.grid) return;

  const y = target.y! + target.h!;
  withAnimationsDisabled(node.grid, () => node.grid!.engine.moveNode(node, { x: 0, y }));
};
